// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './unstyled-link.module.scss';
import Link from 'next/link';
import { UnstyledLinkProps } from './unstyled-link.interfaces';

const UnstyledLink = (props: UnstyledLinkProps): ReactElement => {
  const { className, href, component = 'Link', ...rest } = props;

  if (component == 'a') {
    return <a href={`${href}`} {...rest} className={clsx(styles.root, className)} />;
  }

  return <Link href={href} {...rest} className={clsx(styles.root, className)} />;
};

export default UnstyledLink;
